import {
    Module, VuexModule, Mutation, Action, getModule,
} from 'vuex-module-decorators';
import store from '@/state/store';
import {
    adsAPI, authAPI, campaignAPI, commonsAPI,
} from '@samclick-static-urls';
import { sendPost, sendGet, sendPut } from '@samclick-api-client';
import {
    _isEmpty, _find, _filter, _includes, _forEach, _sortBy,
} from '@samclick-lodash';
import Payload from '@/state/modules/payload';
import { translateProperty, multipleReplace } from '@/utils/common-utils';
import i18n from '@/i18next';
import {sendUAGet} from "@/api-client/unified-api";
import {affiliateAPI} from "@/api-client/static-url-ua";
import {AxiosPromise} from "axios";

@Module({
    namespaced: true, dynamic: true, store, name: 'commons',
})
class CommonsStore extends VuexModule {
    commonsStore: LooseObject = { ...this.init() }

    private init() {
        return {
            affiliateStatus: [
                { value: 2, label: 'aff_status_verified' },
                { value: 1, label: 'aff_status_unverified' },
                { value: 3, label: 'aff_status_closed' },
                { value: 4, label: 'aff_status_blocked' },
                { value: 5, label: 'aff_status_email_verified' },
                { value: 6, label: 'aff_status_more_info' },
                { value: 7, label: 'aff_status_rejected' },
            ],
            casinos: [],
            brandAssignment: [],
            questLevels: [],
            cpas: [],
            services: [],
            mediumsType: [
                { value: 1, label: 'mediums_type_mail' },
                { value: 2, label: 'mediums_type_blog' },
                { value: 3, label: 'mediums_type_video' },
                { value: 4, label: 'mediums_type_sns' },
                { value: 5, label: 'mediums_type_seo' },
                { value: 6, label: 'mediums_type_referral' },
                { value: 7, label: 'mediums_type_offline' },
                { value: 0, label: 'mediums_type_other' },
            ],
            notesCategory: [],
            allServices: [],
            allCasino: [],
            enabledCasino: [],
            markets: [],
            allAdvertisementCategories: [],
            mediumApplyStatus: [
                { value: 1, label: 'Apply' },
                { value: 2, label: 'Approved' },
            ],
            paymentStatus: [
                { value: 1, label: 'Normal' },
                { value: 2, label: 'Hold' },
                { value: 3, label: 'Carryover' },
                { value: 4, label: 'Failed' },
                { value: 5, label: 'Terminated' },
            ],
            accountTypes: [],
            adsType: [],
            promotions: [
                { value: 1, label: 'lookups.promotions_website' },
                { value: 2, label: 'lookups.promotions_seo' },
                { value: 3, label: 'lookups.promotions_banners' },
                { value: 4, label: 'lookups.promotions_ppc' },
                { value: 5, label: 'lookups.promotions_others' },
            ],
            campaignStatus: [
                { value: 1, label: 'lookups.campaign_status_active' },
                { value: 2, label: 'lookups.campaign_status_inactive' },
            ],
            campaigns: [],
            campaignGroup: [],
            btcServices: [],
            preferredLanguages: [
                { value: 'en', label: 'lookups.lang_english' },
                { value: 'jp', label: 'lookups.lang_japanese' },
                { value: 'br', label: 'lookups.lang_portuguese' },
            ],
            selfBilling: [
                { value: 1, label: 'lookups.yes' },
                { value: 0, label: 'lookups.no' },
            ],
            yesOrNo: [
                { value: 1, label: 'lookups.yes' },
                { value: 0, label: 'lookups.no' },
            ],
            localization: {},
            transactionType: [
                { value: 1, label: 'Administrative Adjustments' },
                { value: 2, label: 'Manual Adjustments' },
                { value: 3, label: 'Commission Earnings' },
                { value: 4, label: 'Payment' },
                { value: 5, label: 'Carryover from Adjustments' },
                { value: 6, label: 'Failed Payment' },
                { value: 7, label: 'Affiliate Payout Adjustment'},
                { value: 8, label: 'Operator Commission Adjustment'},
            ],
            transactionStatus: [
                { value: 1, label: 'Paid' },
                { value: 2, label: 'Approved' },
                { value: 3, label: 'Pending' },
                { value: 4, label: 'Rejected' },
                { value: 5, label: 'Deleted'},
                { value: 6, label: 'Failed'},

            ],
            transactionVisible: [
                { value: 1, label: 'Yes' },
                { value: 0, label: 'No' },
            ],
            playerCountry: [],
            allMarketCountries: [],
            accountTypesCrypto: [
                { value: 1, label: 'BTC' },
                { value: 2, label: 'USDT/ERC20' },
                { value: 3, label: 'USDT/TRC20' },
            ],
            paymentAccountTypes: [
                { value: 2, label: 'lookups.pay_acct_ecopayz',},
                { value: 3, label: 'lookups.pay_acct_neteller', allowedRegions: ['Europe', 'EU'] },
                { value: 5, label: 'lookups.pay_acct_banktransfer',},
                { value: 10, label: 'lookups.pay_acct_others', },
                { value: 11, label: 'lookups.pay_acct_skrill', allowedRegions: ['Europe', 'EU'] },
            ],
        };
    }

    get mediumDescription() {
        const self = this;
        return function (type: number) {
            return _find(self.commonsStore.mediumsType, { value: type });
        };
    }

    get mediums() {
        const self = this;
        return function (types: number[]) {
            if (_isEmpty(types)) {
                return self.commonsStore.mediumsType;
            }
            return _filter(self.commonsStore.mediumsType, medium => _includes(types, medium.value));
        };
    }

    get casinoDescription() {
        const self = this;
        return function (casinoID: number) {
            return _find(self.commonsStore.casinos, { id: casinoID });
        };
    }

    get casinoAllDescription() {
        const self = this;
        return function (casinoID: number) {
            return _find(self.commonsStore.allCasino, { id: casinoID });
        };
    }

    get serviceDescription() {
        const self = this;
        return function (serviceID: number) {
            return _find(self.commonsStore.allServices, { id: serviceID });
        };
    }

    get casinoCode() {
        const self = this;
        return function (casinoID: number) {
            const res = _find(self.commonsStore.allCasino, { id: casinoID });
            return res ? res.code : '';
        };
    }

    get serviceName() {
        const self = this;
        return function (serviceID: number) {
            let name = '';
            const result = _find(self.commonsStore.allServices, { id: serviceID });

            if (!result) {
                return name;
            }

            name = result.name_en ? result.name_en : result.name;

            return name;
        };
    }

    get notesDescription() {
        const self = this;
        return function (type: string) {
            return _find(self.commonsStore.notesCategory, { category_code: type });
        };
    }

    get activeCasinos() {
        return this.commonsStore.allCasino;
    }

    get enabledCasinos() {
        return this.commonsStore.enabledCasino;
    }

    get activeServices() {
        return _filter(this.commonsStore.allServices, ['del_flg', 0]);
    }

    get activeAndNotDeletedServices() {
        return _filter(this.commonsStore.allServices, service => service.del_flg === 0 && (service.status === 1));
    }

    get activeAndNotDeletedCasinos() {
        const casinos = _filter(this.commonsStore.allCasino, casino => casino.del_flg === 0 && (casino.status === 1 || casino.status === 5));
        return _sortBy(casinos, [function (o) { return o.code; }]);
    }

    get mediumApplicationStatus() {
        const self = this;
        return function (status: number) {
            return _find(self.commonsStore.mediumApplyStatus, { value: status });
        };
    }

    get paymentStatus() {
        const self = this;
        return function (status: number) {
            return _find(self.commonsStore.paymentStatus, { value: status });
        };
    }

    get indexedAccountTypes() {
        const accountTypes: object[] = [];

        this.commonsStore.accountTypes.forEach((type, index) => {
            accountTypes.push({ value: index + 1, label: type.label });
        });

        return accountTypes;
    }

    get categoryType() {
        const self = this;
        return function (type: number) {
            return _find(self.commonsStore.adsType, { value: type });
        };
    }

    get campaignStatus() {
        const self = this;
        return function (status: number) {
            return translateProperty(_find(self.commonsStore.campaignStatus, { value: status }), 'label');
        };
    }

    get activeCampaign() {
        return _filter(this.commonsStore.campaignGroup, group => group.status === 1);
    }

    get getBTCServices() {
        return this.commonsStore.btcServices;
    }

    get isBTCService() {
        const self = this;
        return function (serviceID: number) {
            return _includes(self.commonsStore.btcServices, serviceID);
        };
    }

    get campaignDescription() {
        const self = this;
        return function (campaignId: number) {
            return _find(self.commonsStore.campaigns, { name: campaignId });
        };
    }

    get getLocalization() {
        return this.commonsStore.localization;
    }

    get transactionStatus() {
        const self = this;
        return function (status: number) {
            return _find(self.commonsStore.transactionStatus, { value: status });
        };
    }

    get transactionType() {
        const self = this;
        return function (type: number) {
            return _find(self.commonsStore.transactionType, { value: type });
        };
    }

    get transactionVisible() {
        const self = this;
        return function (isvisible: number) {
            return _find(self.commonsStore.transactionVisible, { value: isvisible });
        };
    }

    get allAdvertisementCategories() {
        return this.commonsStore.allAdvertisementCategories;
    }

    get advertisementCategoryName() {
        const self = this;
        return function (casinoID: number) {
            const res = _find(self.commonsStore.allAdvertisementCategories, { id: casinoID });
            return res ? i18n.t(res.name) : '';
        };
    }

    get activeMarketCountries() {
        return this.commonsStore.allMarketCountries;
    }
    @Mutation
    SET_QUEST_CPA_CASINOS(data: object) {
        this.commonsStore.casinos = data.casinos || [];
        this.commonsStore.cpas = data.cpas || [];
        this.commonsStore.questLevels = data.quests || [];
    }

  @Mutation
    SET_NOTES_CATEGORY(data: any) {
        this.commonsStore.notesCategory = data || [];
    }

  @Mutation
  SET_SERVICE(services: any) {
      this.commonsStore.services = services || [];
  }

  @Mutation
  SET_ALL_SERVICE(services: any) {
      this.commonsStore.allServices = services || [];
  }

  @Mutation
  SET_ALL_CASINO(services: any) {
      this.commonsStore.allCasino = services || [];
  }

  @Mutation
  SET_ENABLED_CASINO(services: any) {
      this.commonsStore.enabledCasino = services || [];
  }

    @Mutation
  SET_AFFILIATE_MARKETS(markets: any) {
      this.commonsStore.markets = markets || [];
  }

  @Mutation
    SET_ACCOUNT_TYPES(types: string[]) {
        const typesRes: object[] = [];
        if (types) {
            _forEach(types, (type) => {
                typesRes.push({ value: type, label: type });
            });
        }
        this.commonsStore.accountTypes = typesRes;
    }

  @Mutation
  SET_ADS_TYPES(adsType: object[]) {
      const typesRes: object[] = [];
      if (adsType) {
          _forEach(adsType, (type) => {
              typesRes.push({ value: type.id, label: type.name });
          });
      }

      this.commonsStore.adsType = typesRes;
  }

  @Mutation
  SET_CAMPAIGN_GROUP(response: object[]) {
      this.commonsStore.campaignGroup = response || [];
  }

  @Mutation
  SET_CAMPAIGN_LIST(response: object[]) {
      this.commonsStore.campaigns = response || [];
  }

  @Mutation
  SET_ALL_ADS_CATEGORY(adsCategories: any) {
      const categories: object[] = [];
      if (adsCategories) {
          _forEach(adsCategories, (category) => {
              categories.push({ id: category.id, name: `lookups.advertisement_categories_${category.id}` });
          });
      }
      this.commonsStore.allAdvertisementCategories = categories || [];
  }

  @Mutation
  SET_LOCALIZATION(response: object) {
      this.commonsStore.localization = response || {};
  }

  @Mutation
  SET_PLAYER_COUNTRY(response: any) {
      this.commonsStore.playerCountry = response || [];
  }

  @Mutation
  SET_MARKET_COUNTRIES(response: any) {
      this.commonsStore.allMarketCountries = response || [];
  }

  @Action({ rawError: true })
  getQuestCpaCasinos() {
      return new Promise((resolve, reject) => {
          sendGet(`${commonsAPI.fetchQuestCpaCasinos}`, {}).then((response) => {
              this.context.commit('SET_QUEST_CPA_CASINOS', response.data);
              resolve(response);
          }, (error) => {
              reject(error.response);
          });
      });
  }

  @Action({ rawError: true })
  getNotesCategory() {
      return new Promise((resolve, reject) => {
          sendGet(`${commonsAPI.fetchNotesCategory}`, {}).then((response) => {
              this.context.commit('SET_NOTES_CATEGORY', response.data);
              resolve(response);
          }, (error) => {
              reject(error.response);
          });
      });
  }

  @Action({ rawError: true })
  fetchServices() {
      if (!_isEmpty(this.commonsStore.services)) return Promise.resolve(this.commonsStore.services);

      return new Promise((resolve, reject) => {
          sendGet(`${commonsAPI.fetchServices}`, {}).then((response) => {
              this.context.commit('SET_SERVICE', response.data);
              resolve(response);
          }, (error) => {
              reject(error.response);
          });
      });
  }


  @Action({ rawError: true })
  findAffByIdOrEmail(payload: object) {
      return new Promise((resolve, reject) => {
          sendGet(commonsAPI.findAffByIdOrEmail, payload).then((response) => {
              resolve(response);
          }, (error) => {
              reject(error.response);
          });
      });
  }

  @Action({ rawError: true })
  fetchAllServices() {
      return new Promise((resolve, reject) => {
          sendGet(`${commonsAPI.getAllServices}`, {}).then((response) => {
              this.context.commit('SET_ALL_SERVICE', response.data);
              resolve(response);
          }, (error) => {
              reject(error.response);
          });
      });
  }

  @Action({ rawError: true })
  fetchAllCasino() {
      return new Promise((resolve, reject) => {
          sendUAGet(`${affiliateAPI.getBrandSubscription}`, {}).then((response) => {
              this.context.commit('SET_ALL_CASINO', response.data);
              resolve(response);
          }, (error) => {
              reject(error.response);
          });
      });
  }

  @Action({ rawError: true })
  fetchEnabledCasino() {
      return new Promise((resolve, reject) => {
          sendUAGet(`${affiliateAPI.getEnabledBrands}`, {}).then((response) => {
              this.context.commit('SET_ENABLED_CASINO', response.data);
              resolve(response);
          }, (error) => {
              reject(error.response);
          });
      });
  }

    @Action({ rawError: true })
  getAffiliateSubscription() {
      return new Promise((resolve, reject) => {
          sendUAGet(`${affiliateAPI.getAffiliateSubscription}`, {}).then((response) => {
              this.context.commit('SET_AFFILIATE_MARKETS', response.data);
              resolve(response);
          }, (error) => {
              reject(error.response);
          });
      });
  }

  @Action({ rawError: true })
    fetchAccountTypes() {
        return new Promise((resolve, reject) => {
            sendGet(commonsAPI.getAccountTypes).then((response) => {
                this.context.commit('SET_ACCOUNT_TYPES', response.data);
                resolve(response);
            }, (error) => {
                reject(error.response);
            });
        });
    }

  @Action({ rawError: true })
  fetchAdsTypes() {
      return new Promise((resolve, reject) => {
          sendGet(commonsAPI.getAdsType).then((response) => {
              this.context.commit('SET_ADS_TYPES', response.data);
              resolve(response);
          }, (error) => {
              reject(error.response);
          });
      });
  }

  @Action({ rawError: true })
  getCampaignGroups(payload: Payload = new Payload()) {
      return new Promise((resolve, reject) => {
          sendGet(commonsAPI.campaignGroups, payload.data).then((response) => {
              if (payload.storeData) {
                  this.context.commit('SET_CAMPAIGN_GROUP', response.data);
              }
              resolve(response);
          }, (error) => {
              reject(error.response);
          });
      });
  }

  @Action({ rawError: true })
  getCampaignList(payload: Payload = new Payload()) {
      return new Promise((resolve, reject) => {
          sendGet(adsAPI.campaignList, payload.data).then((response) => {
              if (payload.storeData) {
                  this.context.commit('SET_CAMPAIGN_LIST', response.data);
              }
              resolve(response);
          }, (error) => {
              reject(error.response);
          });
      });
  }

  @Action({ rawError: true })
  saveRereferrLog(payload: Payload) {
      return new Promise((resolve, reject) => {
          sendPut(commonsAPI.saveReferrerLog, payload.data, true).then((response) => {
              resolve(response);
          }, (error) => {
              reject(error.response);
          });
      });
  }

  @Action({ rawError: true })
  fetchLocalization() {
      return new Promise((resolve, reject) => {
          sendGet(commonsAPI.localization, undefined, true).then((response) => {
              this.context.commit('SET_LOCALIZATION', response.data);
              resolve(response);
          }, (error) => {
              reject(error.response);
          });
      });
  }

  @Action({ rawError: true })
  clearLocalization() {
      this.context.commit('SET_LOCALIZATION', {});
  }

  @Action({ rawError: true })
  fetchAllAdsCategory() {
      return new Promise((resolve, reject) => {
          sendGet(`${commonsAPI.getAdsCategory}`, {}).then((response) => {
              this.context.commit('SET_ALL_ADS_CATEGORY', response.data);
              resolve(response);
          }, (error) => {
              reject(error.response);
          });
      });
  }

    @Action({ rawError: true })
  fetchPlayerCountry() {
      return new Promise((resolve, reject) => {
          sendUAGet(`${affiliateAPI.getPlayerCountry}`, {}).then((response) => {
              this.context.commit('SET_PLAYER_COUNTRY', response.data);
              resolve(response);
          }, (error) => {
              reject(error.response);
          });
      });
  }

    @Action({ rawError: true })
    fetchAllMarketCountries(payload: Payload = new Payload()) {
        return new Promise((resolve, reject) => {
            sendUAGet(`${affiliateAPI.getAllCountries}`, payload.data).then((response) => {
                const sortedData = response.data.sort((a, b) =>
                    a.country_name.localeCompare(b.country_name)
                );
                this.context.commit('SET_MARKET_COUNTRIES', sortedData);
                resolve(response);
            }, (error) => {
                reject(error.response);
            });
        });
    }

    @Action({ rawError: true })
    fetchAllMarketCountriesPreLogin(payload: Payload = new Payload()) {
        return new Promise((resolve, reject) => {
            sendUAGet(`${affiliateAPI.getAllCountriesPreLogin}`, payload.data).then((response) => {
                const sortedData = response.data.sort((a, b) =>
                    a.country_name.localeCompare(b.country_name)
                );
                this.context.commit('SET_MARKET_COUNTRIES', sortedData);
                resolve(response);
            }, (error) => {
                reject(error.response);
            });
        });
    }



    @Action({ rawError: true })
    getDefaultLanguage() {
        return new Promise((resolve, reject) => {
            sendUAGet(`${affiliateAPI.getDefaultLanguage}`, {}).then((response) => {
                resolve(response);
            }, (error) => {
                reject(error.response);
            });
        });
    }

    @Action({ rawError: true })
    getTurnstileConfig() {
        return new Promise((resolve, reject) => {
            sendUAGet(`${affiliateAPI.getTurnstileConfig}`, {}).then((response) => {
                resolve(response);
            }, (error) => {
                reject(error.response);
            });
        });
    }
}

export default getModule(CommonsStore);
